'use client';
import React from 'react';
import { motion } from 'framer-motion';
import MemberProfile from './MemberProfile';
const members = [
    {
        id: "1",
        name: "Mr. Noleto Visa",
        designation: "Chairman",
        img: "assets/images/board-members/Noleto Visa.jpg"
    },
    {
        id: "2",
        name: "Ms. Bideno Tsopoe",
        designation: "Secretary",
        img: "/assets/images/faculties/Bideno Tsopoe.jpg"
    },
    {
        id: "3",
        name: "Dr. Keviu Shuya",
        designation: "Member",
        img: "assets/images/board-members/Keviu Shuya.jpg"
    },
    {
        id: "4",
        name: "Mr. Kevitho Kera",
        designation: "Member",
        img: "assets/images/board-members/Kevitho Kera.jpg"
    },
    {
        id: "5",
        name: "Mr. Vil Tsukru",
        designation: "Member",
        img: "/assets/images/faculties/Vil Tsukru.jpg"
    },
    {
        id: "6",
        name: "Mr. Brahmanandan K",
        designation: "Member",
        img: "/assets/images/faculties/Brahmanandan K.jpg"
    },
];
export default function BoardMembers() {
    return (
        <>
            <p className='lg:text-5xl text-theme text-center font-bold text-3xl'>Current Board Members</p>
            {/* <motion.article
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ ease: 'easeOut' }}
                viewport={{ once: false }}
                className={` relative pb-4 mb-4`}>

                <MemberProfile name={"Mr. Hosal Angami"} designation={"Chairman"} />
            </motion.article> */}
            <div className="lg:columns-3 columns-1 overflow-hidden mt-10 px-5 pb-5">
                {members.map((member, index) => {
                    return (
                        <>
                            <motion.article
                                key={index}
                                initial={{ y: 50, opacity: 0 }}
                                whileInView={{ y: 0, opacity: 1 }}
                                transition={{ ease: 'easeOut' }}
                                viewport={{ once: false }}
                                className={`py-7 relative pb-4 `}>

                                <MemberProfile name={member.name} designation={member.designation} img={member.img} />
                            </motion.article>
                        </>
                    );
                })}
            </div>
        </>
    );
}
